import EntryNameEditable from './EntryNameEditable';
import EntryEditable from './EntryEditable';
import EntryEditableWithUnit from './EntryEditableWithUnit';
import EntryConst from './EntryConst';

const CustomPosition = ({
  col,
  item,
  index,
  onChange,
  onUnitChange,
  setItems,
  onFocus = () => {},
  descriptionVars,
  showVars,
  imageType,
  imageApiFilter,
  posCol,
}) => {
  return (
    <>
      {col.editable && col.key === 'amount' && (
        <EntryEditableWithUnit
          col={col}
          item={item}
          index={index}
          onChange={onChange}
          onUnitChange={onUnitChange}
          onFocus={onFocus}
        />
      )}
      {col.editable && col.key !== 'amount' && (
        <EntryEditable
          col={col}
          item={item}
          index={index}
          onChange={onChange}
          onFocus={onFocus}
        />
      )}
      {!col.editable && (
        <>
          {col.custom && (
            <EntryConst
              unit={''}
              value={col.custom(item, col.unit)}
              className={col.className}
            />
          )}
          {!col.custom && (
            <EntryConst
              unit={col.unit}
              value={posCol == item.depth ? item.position : item[col.key]}
              className={col.className}
            />
          )}
        </>
      )}
    </>
  );
};

export default CustomPosition;
